import {DeviceInfoDto} from './DeviceInfoDto';
import {WebSocketMessage} from './WebSocketMessage';
import {
    InputSourceType
} from 'botato-botengine-browser/botato/botato-botengine/source/InstantMessagingAdapter/WebSocket/dto/InputSourceType.js';

export class WebSocketEventDto extends WebSocketMessage {

    public userId!: string;

    constructor(
        public eventKey: string,
        language: string,
        deviceInfo: DeviceInfoDto,
        clientId: string,
        botId: string,
        inputSource?: InputSourceType,
        // Data can be any
        // eslint-disable-next-line
        public data?: any,
        authToken?: string
    ) {
        super(language, clientId, botId, {deviceInfo: deviceInfo}, inputSource, authToken);
    }
}

